import { memo } from 'react';

import clsx from 'clsx';
import { addHours } from 'date-fns';

import Popup from '@popup/components/Popup';
import PopupWrapper from '@ui/components/PopupWrapper';
import { formatCsHour } from '@utils/formatCs';

interface SelectedTimeslotProps {
  length: number;
  startDate: Date;
  isTillMidnight?: boolean;
  isFullDay?: boolean;
  isHovered?: boolean;
  isDividedByTwo?: boolean;
  isSelected?: boolean;
  onMouseEnter?: () => void;
}

const SelectedTimeslotModal = ({
  length,
  startDate,
  isTillMidnight,
  isFullDay,
  isHovered = false,
  isDividedByTwo = false,
  isSelected = false,
  onMouseEnter,
}: SelectedTimeslotProps) => {
  const getText = () => {
    if (isFullDay) {
      return 'Celý den';
    }

    const hoursToAdd =
      startDate.getHours() + length > 24 ? 24 - startDate.getHours() : length;

    return `${formatCsHour(startDate)} - ${
      isTillMidnight
        ? 'Do zavíračky'
        : formatCsHour(addHours(startDate, hoursToAdd))
    }`;
  };

  return (
    <div
      // eslint-disable-next-line tailwindcss/enforces-negative-arbitrary-values
      className={clsx(
        'absolute bottom-[calc(100%+4px)] z-10 flex min-w-[100px] items-center justify-center',
        (!isDividedByTwo || !isHovered) && 'left-1/2 -translate-x-1/2',
        isDividedByTwo &&
          isHovered &&
          isSelected &&
          'left-full -translate-x-[calc(100%-16px)]',
        isDividedByTwo &&
          isHovered &&
          !isSelected &&
          'left-1/2 -translate-x-[calc(100%-72px)]',
      )}
      onMouseEnter={onMouseEnter}
    >
      <Popup type="tooltip">
        <PopupWrapper isMaxHeightLimit={true}>
          <span className="whitespace-nowrap">{getText()}</span>
        </PopupWrapper>
      </Popup>
    </div>
  );
};

export default memo(SelectedTimeslotModal, (prev, next) => {
  return (
    prev.length === next.length &&
    prev.startDate === next.startDate &&
    prev.isTillMidnight === next.isTillMidnight &&
    prev.isFullDay === next.isFullDay &&
    prev.isHovered === next.isHovered &&
    prev.isDividedByTwo === next.isDividedByTwo
  );
});
